import { ABUSE_TYPE } from '@/src/features/abuse/models/Abuse.enums'
import { ReportAbuseModal } from '@/src/features/abuse/ui/ReportAbuseModal/ReportAbuseModal'
import { useToast } from '@/src/general/components/ToastContext'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

import { useBlockConversationMutation } from '../../services/useBlockConversationMutation'

type TReportMessageModalProps = {
  text?: string
  conversationId: number
  messageId?: number
  onClose: () => void
}

export const ReportMessageModal = ({ text, conversationId, messageId, onClose }: TReportMessageModalProps) => {
  const { addToast } = useToast()
  const { t } = useTranslate()

  const { mutate } = useBlockConversationMutation(conversationId)

  const handleMessageReported = () => {
    mutate()
    addToast({ colors: 'success', iconName: ICON.MESSAGE_INFO, message: t('message.reported') })
  }

  return (
    <ReportAbuseModal
      showModal={!!text && !!messageId}
      onClose={onClose}
      onDone={handleMessageReported}
      objectId={messageId ?? 0}
      objectType={ABUSE_TYPE.MESSAGE}
      text={text ?? ''}
    />
  )
}
